<template>
	<div ref="">
		<div class="SiftPanel" style="border:0px solid #bbbbbb; height:30px; margin-top:5px;">
			<div class="Capt DIVNoSelect" style="flex:0 0 auto; border:0; width:160px;  margin-top:-1px; margin-left:20px; color:#aaaaaa;">客户ID</div>
			<input type="text" style="width:240px;" maxlength="30" v-model="custId" disabled=true>
		</div>
		<div class="SiftPanel" style="border:0px solid #bbbbbb; height:30px; margin-top:5px;">
			<div style="width:100%; height:1px; background:#bbbbbb;"></div>
		</div>

		<div class="SiftPanel" style="border:0px solid #bbbbbb; height:40px;">
			<div class="Capt DIVNoSelect" style="flex:0 0 auto; border:0; width:160px; color:#ff0000;  margin-top:-1px; margin-left:20px;">客户名称</div>
			<input type="text" style="width:240px;" maxlength="30" v-model="custName">
			<div class="NButton DIVNoSelect" style="width:32px; height:32px; background:url(../static/images/op_fin.png); margin-top:-1px; margin-left:10px;" @click="onCustClick"></div>
		</div>

		<div class="SiftPanel" style="border:0px solid #bbbbbb; height:40px;">
			<div class="Capt DIVNoSelect" style="flex:0 0 auto; border:0; width:160px;  margin-top:-1px; margin-left:20px; color:#ff0000;">销售</div>
			<input type="text" style="width:240px;" maxlength="20" v-model="carSaler">
		</div>

		<div class="SiftPanel" style="border:0px solid #bbbbbb; height:40px;">
			<div class="Capt DIVNoSelect" style="flex:0 0 auto; border:0; width:160px;  margin-top:-1px; margin-left:20px; color:#ff0000;">订单号</div>
			<input type="text" style="width:240px;" maxlength="30" v-model="aiCert">
		</div>

		<div class="SiftPanel" style="border:0px solid #bbbbbb; height:40px;">
			<div class="Capt DIVNoSelect" style="flex:0 0 auto; border:0; width:160px;  margin-top:-1px; margin-left:20px; color:#ff0000;">金额(美元,元)</div>
			<input type="text" style="width:100px;" maxlength="6" v-model="aiMoney">
		</div>

		<div style="float:left; width:100%; height:40px; border:0px solid red; margin-top:10px;">
			<div class="NButton DIVNoSelect" style="padding-left:10px; padding-right:10px; margin-top:16px; margin-left:50px;" @click="onCancelClick">{{getLangText("取消")}}</div>
			<div class="NButton DIVNoSelect" style="padding-left:10px; padding-right:10px; margin-top:16px; margin-right:50px; float:right;" @click="onOKClick">{{getLangText("确定")}}</div>
		</div>
	</div>
</template>

<script>

import check      from '../cf/cck'

export default {
	name: 'airNew',
	components:{
		check,
	},
	data () {
		return {
			carSaler: "",                // 销售
			aiCert: "",                  // 订单号
			aiMoney: "",                 // 续费金额
			custId: "",                  //
			custName: "",
			devoCode: "",                // 授权码
		}
	},
	mounted: function(){

	},
	computed:{

	},
	methods:{
		onCustClick: function(){
			this.custId = "";
			let body={ custName: this.custName };

			this.doTrade( "POST", ServAddr+"/api/pub/custNameQry", this.onCustClickOK, true, body, null );
		},
		onCustClickOK: function(res ){
			this.appRoot.app.closeDlgRun();

			let data=res.body;
			if( data.code != "200" )
			{
				this.appRoot.app.showDlgTip( 1200, this.getErrorText(data.code), this.CLR.Err );
				return;
			}

			this.custId = data.body.custId;
		},
		onCancelClick: function(){
			this.$parent.onPopWinClose( );
		},
		onOKClick: function( ){
			if( this.custId=="" ) { alert( "请核对客户" ); return; }
			if( this.carSaler=="" ) { alert( "请输入客户或销售" ); return; }
			console.log( parseInt(this.aiMoney), this.aiMoney, parseInt(this.aiMoney)!=this.aiMoney );
			if( parseInt(this.aiMoney)!=this.aiMoney ){ alert( "金额格式错误" ); return; }

			let body={	carSaler: this.carSaler,
						carCertificate: this.aiCert,
						carBuyMoney:  parseInt(this.aiMoney)*100,
						carCustId: this.custId
				 };
			this.doTrade( "POST", ServAddr+"/api/aiRecharge/add", this.onFeeNewOK, true, body, null );
		},
		onFeeNewOK: function( res ){
			this.appRoot.app.closeDlgRun();

			let data=res.body;
			this.$parent.onPopWinClose2();
			if( data.code == 200 )
				 this.appRoot.app.showDlgTip( 1200, LangText("保存成功"), this.CLR.Suc, this.$parent.onPopWinClose, true );
			else this.appRoot.app.showDlgTip( 1200, LangText("保存失败"), this.CLR.Err, this.$parent.onPopWinClose, true );
		},
	}
}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// airNew.vue?77f9f884